import script from "./general-khach-hang.vue?vue&type=script&setup=true&lang=js"
export * from "./general-khach-hang.vue?vue&type=script&setup=true&lang=js"

import "./general-khach-hang.vue?vue&type=style&index=0&id=23f07c95&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f07c95"]])

export default __exports__